var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpalndIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 15,
    viewBox: "0 0 24 15",
    fill: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 1.5H12",
    stroke: "#383838",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 6.6C23.4971 6.6 23.9 7.00294 23.9 7.5C23.9 7.99706 23.4971 8.4 23 8.4L23 7.5L23 6.6ZM0.363604 8.1364C0.0121327 7.78493 0.0121326 7.21508 0.363604 6.86361L6.09117 1.13604C6.44264 0.784569 7.01249 0.784569 7.36396 1.13604C7.71543 1.48751 7.71543 2.05736 7.36396 2.40883L2.27279 7.5L7.36396 12.5912C7.71543 12.9426 7.71543 13.5125 7.36396 13.864C7.01249 14.2154 6.44264 14.2154 6.09117 13.864L0.363604 8.1364ZM23 7.5L23 8.4L1 8.4L1 7.5L1 6.6L23 6.6L23 7.5Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 13.5H12",
    stroke: "#383838",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpalndIcon);
export default __webpack_public_path__ + "static/media/expalndIcon.bd93b44e09f7c95e3aee1b2370d9300b.svg";
export { ForwardRef as ReactComponent };